module.exports = __webpack_public_path__ + "img/st.cb85c9f9.jpg";